/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnedisConnectionErrorHistoryPagedList } from '../../models/enedis-connection-error-history-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface GetEnedisConnectionErrorHistory$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function getEnedisConnectionErrorHistory(http: HttpClient, rootUrl: string, params: GetEnedisConnectionErrorHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>> {
  const rb = new RequestBuilder(rootUrl, getEnedisConnectionErrorHistory.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>;
    })
  );
}

getEnedisConnectionErrorHistory.PATH = '/enedis/connection/{uid}/errorHistory';
